module.exports = __webpack_public_path__ + "static/media/14.Cube-Testing-Machine-2000-KN.a4a63873.webp";